module.exports = __webpack_public_path__ + "static/media/ejobindiaaward.957d5ffb.jpg";